import { CloseRounded, ContactPage, Info } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import ElectricCarIcon from "@mui/icons-material/ElectricCar";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import HomeIcon from "@mui/icons-material/Home";
import PaymentsIcon from "@mui/icons-material/Payments";
import { Link, styled } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useState } from "react";

import { primary } from "../constants/theme";
import { Context } from "../context/context";
import { sendAnalytics } from "../utils/analyticsCommon";
import { useMobile } from "../utils/findViewport";

import StoreIcon from "@mui/icons-material/Store";
import { ActiveItemValue } from "../context/navbarContext";
import { imagesWEBP } from "../constants/webpImages";

const CustomAppBar = styled(Box)(() => ({
  minHeight: { md: "74px" },
  position: "inherit",
  ".container": {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  ".toolbar": {
    padding: 0,
    flex: 1,
    justifyContent: "space-between",
    minHeight: "74px",
  },
  ".getoffer": {
    fontSize: "16px",
    lineHeight: "1%",
    textAlign: "center",
    color: primary.white,
    border: `1.5px solid ${primary.white}`,
    borderRadius: "146.7px",
    padding: "18px 24px",
  },
  ".navItems": {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "1.7em",
    color: "#333333",
    textTransform: "none",
    width: "120px",
  },

  ".Mui-selected.navItems ": {
    fontWeight: "700",
    color: primary.main,
  },
  ".MuiTabs-indicator": {
    backgroundColor: primary.white,
    bottom: "5px",
  },
  ".MuiTabs-flexContainer": {
    minHeight: "74px",
  },
  ".icons-mobile": {
    display: "flex",
    alignItems: "center",
  },
  ".MuiSvgIcon-fontSizeLarge": { fontSize: "2em" },

  ".image-section": {
    objectFit: "contain",
    width: "100% !important",
    position: "relative !important",
  },
}));

const drawerWidth = "60%";
const navItems = [
  {
    id: 0,
    name: "Home",
    link: "/",
    icon: <HomeIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 1,
    name: "Vehicles",
    link: "/electric-commercial-vehicles",
    icon: <ElectricCarIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 2,
    name: "Cargo Vehicles",
    link: "enquiry/goods-electric-commercial",
    icon: <ElectricCarIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 3,
    name: "Passenger Vehicles",
    link: "/enquiry/electric-passenger",
    icon: <ElectricCarIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 4,
    name: "Referral",
    link: "/referral",
    icon: <GroupAddIcon sx={{ color: `${primary.main}` }} />,
  },

  // {
  //   id: 6,
  //   name: "Articles",
  //   link: "/articles",
  //   icon: <DocumentScannerIcon sx={{ color: `${primary.main}` }} />,
  // },
  {
    id: 5,
    name: "Contact us",
    link: "/contactus",
    icon: <ContactPage sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 6,
    name: "Finance",
    link: "/finance",
    icon: <PaymentsIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 7,
    name: "About us",
    link: "/aboutus",
    icon: <Info sx={{ color: `${primary.main}` }} />,
  },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Header = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const mobile = useMobile();
  const state = useContext(Context);
  const { showHeader, hideHeader } = useContext(Context);
  const { showWhatsappPopup } = useContext(Context);
  const { activeItemChanges } = useContext(ActiveItemValue);
  const value = state?.value;
  const navigate = useRouter();
  const handleChange = (event, newValue) => {
    let activeTab = navItems.filter((obj) => obj.id === newValue);
    activeItemChanges(newValue);

    if (activeTab[0]?.link === "/articles") {
      navigate.push(activeTab[0]?.link);
      navigate.reload(activeTab[0]?.link);
    } else {
      navigate.push(activeTab[0]?.link);
    }
  };
  const handleDrawerToggle = () => {
    if (!mobileOpen) {
      sendAnalytics("ham_menu_clicked", {}, "en");
    }
    // setMobileOpen(!mobileOpen);

    if (state.showHeaderValue) {
      hideHeader();
    } else {
      showHeader();
    }
  };

  useEffect(() => {
    let activeTab = navItems.filter((obj) => obj.link === navigate.pathname);
    activeItemChanges(activeTab[0]?.id);
    // eslint-disable-next-line
  }, [navigate.pathname]);

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box
        sx={{
          p: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Link 
            href="/" 
            onClick={(e) => {
              e.preventDefault();
              sendAnalytics("home_icon_clicked", {}, "en");
              navigate.push("/");
            }}
          >
            <Image
              style={{ height: "25px"}}
              src={imagesWEBP?.brandLogo}
              width="120"
              height="32"
              alt="Turno club logo"
              className={"image-section"}
            />
          </Link>
        </Box>
        <IconButton>
          <CloseRounded />
        </IconButton>
      </Box>
      <Divider />
      <List sx={{ textAlign: "left" }}>
        {navItems
          ?.filter((item, index) => {
            const skipMenuItem = props?.isHomePage
              ? ["Vehicles", "Finance"]
              : ["Cargo Vehicles", "Passenger Vehicles"];
            if (skipMenuItem.includes(item.name)) {
              return false;
            } else {
              return true;
            }
          })
          ?.map((item, index) => {
            return (
              <Link 
                key={index}
                href={item.link} 
                underline="none"
                onClick={(e) => {
                  e.preventDefault();
                  let payload = {
                    option_selected: item.name,
                    vehicle_id: "",
                    vehicle_name: "",
                  };
                  sendAnalytics("ham_menu_option_selected", payload, "en");
                  navigate.push(item.link);
                }}
              >
                <ListItem
                  style={{ padding: "6px 14px" }}
                  disablePadding
              >
                <ListItemButton
                  sx={{
                    textAlign: "left",
                    color: `${value === item.id ? "#024670" : "black"}`,
                    background: "#f7f7f7",
                    padding: "6px 14px",
                    maxWidth: "164px",
                    margin: "0px 0px 10px 10px",
                    width: "fit-content",
                    borderRadius: "8px",
                  }}
                >
                  {item.icon}
                  <ListItemText
                    sx={{ ml: "16px", fontSize: "14px" }}
                    primary={item.name}
                  />
                </ListItemButton>
              </ListItem>
              </Link>
            );
          })}

          <Link 
            href="/articles" 
            underline="none"
            onClick={(e) => {
              e.preventDefault();
              let payload = {
                option_selected: "Articles",
                vehicle_id: "",
                vehicle_name: "",
              };
              sendAnalytics("article_clicked", payload, "en");
              navigate.push("/articles", undefined, { locale: 'en' });
            }}
          >
            <ListItem
              style={{ padding: "6px 14px", cursor: "pointer" }}
              key={"Articles"}
              disablePadding
          >
            <ListItemButton
              sx={{
                textAlign: "left",
                color: `${value === 7 ? "#024670" : "black"}`,
                background: "#f7f7f7",
                padding: "6px 14px",
                maxWidth: "164px",
                margin: "0px 0px 8px 10px",
                width: "fit-content",
                borderRadius: "8px",
              }}
            >
              <DocumentScannerIcon sx={{ color: `${primary.main}` }} />
              <ListItemText
                sx={{ ml: "16px", fontSize: "14px" }}
                primary={"Articles"}
              />
            </ListItemButton>
          </ListItem>
          </Link>

        <Link
          href="https://www.turno.club/brand-store"
          target="_self"
          rel="noreferrer"
          underline="none"
        >
          <ListItem
            style={{ padding: "6px 14px" }}
            key={"Showroom"}
            href="https://www.turno.club/brand-store"
            disablePadding
            onClick={() => {
              let payload = {
                option_selected: "Showroom",
                vehicle_id: "",
                vehicle_name: "",
              };
              sendAnalytics("brand_store_clicked", payload, "en");
            }}
          >
            <ListItemButton
              sx={{
                textAlign: "left",
                color: `${value === 7 ? "#024670" : "black"}`,
                background: "#f7f7f7",
                padding: "6px 14px",
                maxWidth: "164px",
                margin: "0px 0px 8px 10px",
                width: "fit-content",
                borderRadius: "8px",
              }}
            >
              <StoreIcon sx={{ color: `${primary.main}` }} />
              <ListItemText
                sx={{ ml: "16px", fontSize: "14px" }}
                primary={"Showroom"}
              />
            </ListItemButton>
          </ListItem>
        </Link>

        <Link 
          href="https://www.turnovolt.in" 
          underline="none"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            let payload = {
              option_selected: "Turno Volt",
              vehicle_id: "",
              vehicle_name: "",
            };
            sendAnalytics("turno_volt_clicked", payload, "en");
          }}
        >  
          <ListItem>
            <ListItemButton
             sx={{
              textAlign: "left",
              color: `${value === 7 ? "#024670" : "black"}`,
              background: "#f7f7f7",
              padding: "6px 14px",
              maxWidth: "164px",
              margin: "0px 0px 8px 10px",
              width: "fit-content",
              borderRadius: "8px",
            }}
            >
              <ElectricCarIcon sx={{ color: `${primary.main}` }} />
              <ListItemText
                sx={{ ml: "16px", fontSize: "14px" }}
                primary={"Turno Volt"}
              />
            </ListItemButton>
          </ListItem>
        </Link>
        {/* <Link
          href="https://game.turno.club/"
          target="_self"
          rel="noreferrer"
          underline="none"
        >
          <ListItem
            key={"Play & Earn"}
            href="https://game.turno.club/"
            disablePadding
            onClick={() => {
              let payload = {
                option_selected: "Play & Earn",
                vehicle_id: "",
                vehicle_name: "",
              };
              sendAnalytics("play_and_earn_clicked", payload, "en");
            }}
          >
            <ListItemButton
              sx={{
                textAlign: "left",
                color: `${value === 7 ? "#024670" : "black"}`,
                background: "#f7f7f7",
                padding: "6px 14px",
                maxWidth: "164px",
                margin: "0px 0px 21px 10px",
                width: "fit-content",
                borderRadius: "8px",
              }}
            >
              <ToysIcon sx={{ color: `${primary.main}` }} />
              <ListItemText
                sx={{ ml: "16px", fontSize: "14px" }}
                primary={"Play & Earn"}
              />
            </ListItemButton>
          </ListItem>
        </Link> */}
      </List>
    </Box>
  );

  let height = "64px";
  return (
    <CustomAppBar elevation={0}>
      {/* {mobile ? <MemoizedWhatsAppDrawer /> : <MemoizedWhatsAppPopup />} */}

      <Box
        sx={{
          display: "flex",
          minHeight: { xs: "0px", md: "74px" },
          justifyContent: "space-between",
        }}
      >
        <Box component="nav">
          <Drawer
            anchor={"right"}
            //container={container}
            variant="temporary"
            open={state.showHeaderValue}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                borderRadius: "20px 0px 0px 20px",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
      </Box>
    </CustomAppBar>
  );
};

export const MemoizedTabHeader = React.memo(Header);
